export class UserGenericConstants {

  static readonly Sections = {
    ALL: [0, 1, 2, 3, 4, 5],
    NONE: [],
    RESET: [0]
  }
}